import React, { memo } from "react"
import { Box, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import { NavLink } from "react-router-dom"
import { AuthorTools } from "@components/Author/AuthorTools"
import { PaperBox } from "@components/Boxes/PaperBox"

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    transition: "all 0.3s ease-in-out"
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "all 0.3s ease-in-out"
  },
  titleContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    marginRight: theme.spacing(2),
    textDecoration: "none"
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: "20px",
    color: theme.palette.text.primary
  },
  author: {
    fontSize: 14,
    lineHeight: "16px",
    color: theme.palette.text.secondary
  }
}))

const GridArticle = memo(({ knowledge, onEdit, onDelete, onCopy, onMove }) => {
  const classes = useStyles()
  const { id, title, author } = knowledge

  return (
    <PaperBox>
      <Box className={classes.container} component={NavLink} to={`/knowledge/article/${id}`}>
        <Box className={classes.header}>
          <Box className={classes.titleContainer}>
            <Typography className={classes.title}>{title}</Typography>
            <Box className={classes.author}>
              {author.firstName} {author.lastName}
            </Box>
          </Box>
          <AuthorTools
            item={knowledge}
            author={author.id}
            onEdit={onEdit}
            onDelete={onDelete}
            onCopy={onCopy}
            onMove={onMove}
          />
        </Box>
      </Box>
    </PaperBox>
  )
})

GridArticle.displayName = "GridArticle"

export { GridArticle }
